import React from 'react'
import { Form, Grid, Icon } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import InputField from '../../../commonComponents/formComponents/inputField'
import { TranslateContext } from '../TranslateContext'

export default function dutiesTaxes() {
  let dutyIndex = 0
  let totalDuty = 1
  let isFormDisabled = false

  const translate = React.useContext(TranslateContext).translate;
  return (
    <React.Fragment>
      <Form.Group className='float-container mg-t-15' widths='equal'>
        <div
          style={{
            textTransform: 'uppercase',
            textAlign: 'center',
          }}
        >
          <span>
            <strong>{translate("DUT_TAX", {ns:["default", "lineItem"]})}</strong>
          </span>
        </div>
        <Grid>
          <Grid.Row columns={'3'}>
            <Grid.Column
              className={`divFormFeild icon-gbp b-rw-0 ${dutyIndex === 0 ? 'b-tlr-5' : ''} ${
                dutyIndex === totalDuty - 1 ? 'border-bottom b-blr-5' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxAmount-${dutyIndex}`}
                type='number'
                label={translate("PREV_DUT", {ns:["default", "lineItem"]})}
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  // dispatch(
                  //   updateLineItemDutyFeild(invoiceIndex,
                  //     lineItemIndex,
                  //     dutyIndex,
                  //     "taxAmount",
                  //     value
                  //   )
                  // );
                }}
                onBlur={(value) => {
                  // dispatch(
                  //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                  // );
                }}
                disabled={false}
              />
            </Grid.Column>

            <Grid.Column
              className={`divFormFeild icon-gbp b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxAmount-${dutyIndex}`}
                type='number'
                label={translate("CON_DUT", {ns:["default", "lineItem"]})}
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  // dispatch(
                  //   updateLineItemDutyFeild(invoiceIndex,
                  //     lineItemIndex,
                  //     dutyIndex,
                  //     "taxAmount",
                  //     value
                  //   )
                  // );
                }}
                onBlur={(value) => {
                  // dispatch(
                  //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                  // );
                }}
                disabled={false}
              />
            </Grid.Column>
            <Grid.Column
              className={`divFormFeild icon-gbp  ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxAmount-${dutyIndex}`}
                type='number'
                label={translate("COR_DUT", {ns:["default", "lineItem"]})}
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  // dispatch(
                  //   updateLineItemDutyFeild(invoiceIndex,
                  //     lineItemIndex,
                  //     dutyIndex,
                  //     "taxAmount",
                  //     value
                  //   )
                  // );
                }}
                onBlur={(value) => {
                  // dispatch(
                  //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                  // );
                }}
                disabled={false}
              />
            </Grid.Column>

            {/* <Grid.Column
              width={'2'}
              className={`divFormFeild icon-gbp ${dutyIndex === 0 ? 'b-trr-5' : ''}  ${
                dutyIndex === totalDuty - 1 || dutyIndex === 1 ? 'border-bottom b-brr-5' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxAmount-${dutyIndex}`}
                type='number'
                label='Taxes'
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  // dispatch(
                  //   updateLineItemDutyFeild(invoiceIndex,
                  //     lineItemIndex,
                  //     dutyIndex,
                  //     "taxAmount",
                  //     value
                  //   )
                  // );
                }}
                onBlur={(value) => {
                  // dispatch(
                  //   saveLineItemDutyFeild(invoiceIndex , lineItemIndex, dutyIndex, "taxAmount")
                  // );
                }}
                disabled={true}
              />
            </Grid.Column> */}
          </Grid.Row>
          <br />
          <br />
          <br />{' '}
          <Grid.Row columns='7'>
            <Grid.Column
              className={`divFormFeild b-rw-0 ${dutyIndex === 0 ? 'b-tlr-5' : ''} ${
                dutyIndex === totalDuty - 1 ? 'border-bottom b-blr-5' : ''
              }`}
            >
              <DropDown
                id={`taxType-${dutyIndex}`}
                label={translate("TAX_TYPE", {ns:["default", "lineItem"]})}
                disabled={isFormDisabled}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={[]}
                text={'Select'}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'taxType',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxType'))
                }}
              />
              <Icon
                disabled={isFormDisabled}
                style={{
                  marginTop: '-18px',
                  position: 'relative',
                  float: 'right',
                  color: 'gray',
                }}
                name='cancel'
                className='close link icon'
                onClick={() => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxType', '')
                  //   )
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxType'))
                }}
              />
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={`divFormFeild inputBox  b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxBase-${dutyIndex}`}
                label={translate("DUT_TAX_BASE", {ns:["default", "lineItem"]})}
                type='number'
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'taxBase',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxBase'))
                }}
                disabled={isFormDisabled}
              />
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={`divFormFeild b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <DropDown
                id={`mopCode-${dutyIndex}`}
                label={translate("RATE", {ns:["default", "lineItem", "lineItem"]})}
                disabled={isFormDisabled}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={[]}
                text={'Select'}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(
                  //     saveLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       fasSent
                  //     )
                  //   )
                }}
              />
              <Icon
                style={{
                  marginTop: '-18px',
                  position: 'relative',
                  float: 'right',
                  color: 'gray',
                }}
                name='cancel'
                className='close link icon'
                disabled={isFormDisabled}
                onClick={() => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode', '')
                  //   )
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode'))
                }}
              />
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={`divFormFeild b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxBase-${dutyIndex}`}
                label={translate("QTY", {ns:["default", "lineItem"]})}
                type='number'
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'taxBase',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxBase'))
                }}
                disabled={false}
              />
            </Grid.Column>
            <Grid.Column
              width='2'
              className={`divFormFeild   b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <DropDown
                id={`mopCode-${dutyIndex}`}
                label={'Uom'}
                disabled={isFormDisabled}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={[]}
                text={'Select'}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(
                  //     saveLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       fasSent
                  //     )
                  //   )
                }}
              />
              <Icon
                style={{
                  marginTop: '-18px',
                  position: 'relative',
                  float: 'right',
                  color: 'gray',
                }}
                name='cancel'
                className='close link icon'
                disabled={isFormDisabled}
                onClick={() => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode', '')
                  //   )
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode'))
                }}
              />
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={`divFormFeild   b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <DropDown
                id={`mopCode-${dutyIndex}`}
                label={translate("PAYABLE", {ns:["default", "lineItem"]})}
                disabled={isFormDisabled}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={[]}
                text={'Select'}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(
                  //     saveLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       fasSent
                  //     )
                  //   )
                }}
              />
              <Icon
                style={{
                  marginTop: '-18px',
                  position: 'relative',
                  float: 'right',
                  color: 'gray',
                }}
                name='cancel'
                className='close link icon'
                disabled={isFormDisabled}
                onClick={() => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode', '')
                  //   )
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode'))
                }}
              />
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={`divFormFeild b-rw-0 ${
                dutyIndex === totalDuty - 1 ? 'border-bottom' : ''
              }`}
            >
              <InputField
                isLabel={false}
                id={`taxBase-${dutyIndex}`}
                label={translate("DEFERRED", {ns:["default", "lineItem"]})}
                type='number'
                value={''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'taxBase',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'taxBase'))
                }}
                disabled={false}
              />
            </Grid.Column>
            <Grid.Column
              width={'1'}
              className={`divFormFeild ${dutyIndex === 0 ? 'b-trr-5' : ''}  ${
                dutyIndex === totalDuty - 1 || dutyIndex === 1 ? 'border-bottom b-brr-5' : ''
              }`}
            >
              <DropDown
                id={`mopCode-${dutyIndex}`}
                label={'Mop'}
                disabled={isFormDisabled}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={[]}
                text={'Select'}
                onChange={(value) => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       value
                  //     )
                  //   )
                }}
                onBlur={(value) => {
                  //   dispatch(
                  //     saveLineItemDutyFeild(
                  //       invoiceIndex,
                  //       lineItemIndex,
                  //       dutyIndex,
                  //       'mopCode',
                  //       fasSent
                  //     )
                  //   )
                }}
              />
              <Icon
                style={{
                  marginTop: '-18px',
                  position: 'relative',
                  float: 'right',
                  color: 'gray',
                }}
                name='cancel'
                className='close link icon'
                disabled={isFormDisabled}
                onClick={() => {
                  //   dispatch(
                  //     updateLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode', '')
                  //   )
                  //   dispatch(saveLineItemDutyFeild(invoiceIndex, lineItemIndex, dutyIndex, 'mopCode'))
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Group>
    </React.Fragment>
  )
}
